import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [teams, setTeams] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("tpc_team"));

  const loadTeams = useCallback(async () => {
    const { data } = await api.get("/teams");
    setTeams(data);
    return data;
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("tpc_token")) return setUser(false);
    api.get("/auth/me")
      .then((r) => { setUser(r.data); loadTeams(); })
      .catch(() => { localStorage.removeItem("tpc_token"); setUser(false); });
  }, [loadTeams]);

  const signIn = (data) => {
    localStorage.setItem("tpc_token", data.token);
    setUser(data.user);
    loadTeams();
  };
  const signOut = () => {
    localStorage.removeItem("tpc_token");
    setUser(false);
    setTeams([]);
  };
  const setActiveTeam = (id) => {
    localStorage.setItem("tpc_team", id);
    setActiveId(id);
  };
  const activeTeam = teams.find((t) => t.id === activeId) || teams[0] || null;

  return (
    <Ctx.Provider value={{ user, teams, activeTeam, loadTeams, signIn, signOut, setActiveTeam }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
